module.exports = __webpack_public_path__ + "static/media/light_bulb.681f1320.png";